import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { OrdemServico } from "./ordem-servico.model";
import { apiName } from "./data.service";

@Injectable()
export class OrdemServicoApiService {
    private includeFilter: any = ["bem",{"localidade":"endereco"},"odometroHorimetro"];

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: OrdemServico, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: OrdemServico, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"dataEntrada","include":this.includeFilter};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetByQuery(query: any, done: any) {
        let filter: any = {"order":"dataEntrada","include":this.includeFilter};
        filter.where = query;
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":this.includeFilter};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetApiUrl() {
        return apiName;
    }

    onGetAllMateriaisServices(done: any) {
        let object: any = {"ativo":true,"sort":"descricao"};
        this._restService.onGetPostCustom(apiName + '/busca/itens', object, done);
    }

    onGetByIdMateriaisServicos(ordemServicoId: number, done: any) {
        let object: any = {"ativo":true,"ordemServicoId":ordemServicoId};
        this._restService.onGetPostCustom(apiName + '/busca/itens/os', object, done);
    }

    onGetByFilter(filter: any, done: any) {
        filter.include = this.includeFilter;
        filter.order = "dataEntrada";
        this._restService.onGetPost(apiName, filter, done);
    }

    onPostCustomApiUrl() {
        return apiName + '/busca/itens';
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/shared/ordem-servico-api.service.ts
 **/